// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NUhIFS0BHpH91inuPT83 {
  display: flex;
  align-items: flex-start;
  margin-bottom: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid #EFEFEF;
}
@media only screen and (max-width: 1259px) {
  .NUhIFS0BHpH91inuPT83 {
    margin-bottom: 32px;
    padding-bottom: 32px;
  }
}
@media only screen and (max-width: 1023px) {
  .NUhIFS0BHpH91inuPT83 {
    display: block;
  }
}
@media only screen and (max-width: 767px) {
  .NUhIFS0BHpH91inuPT83 {
    margin-bottom: 32px;
    padding-bottom: 32px;
  }
}
.dark-mode .NUhIFS0BHpH91inuPT83 {
  border-color: #272B30;
}

.d_zIGcuR_Y1T1lDVBdYl {
  display: flex;
  align-items: center;
  flex-grow: 1;
}
@media only screen and (max-width: 1023px) {
  .d_zIGcuR_Y1T1lDVBdYl {
    margin-bottom: 16px;
  }
}
@media only screen and (max-width: 767px) {
  .d_zIGcuR_Y1T1lDVBdYl {
    margin-bottom: 12px;
  }
}

.oaAoEyiqqttA__hTS_8V {
  position: relative;
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  margin-right: 16px;
}
.oaAoEyiqqttA__hTS_8V img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

._S_Y_dUD5Y7PYr7IIX_A {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 24px;
  height: 24px;
  border: 2px solid #FFFFFF;
  border-radius: 50%;
  background: #2A85FF;
  font-size: 0;
  transition: background 0.2s;
}
._S_Y_dUD5Y7PYr7IIX_A svg {
  fill: #FFFFFF;
}
._S_Y_dUD5Y7PYr7IIX_A:hover {
  background: #1176ff;
}

@media only screen and (max-width: 767px) {
  .qQMaOcVcan1YPfQ8FfNZ {
    font-size: 20px;
  }
}

.XmSZemaA3eBJ_y9yMrKe {
  font-size: 12px;
  color: #6F767E;
}

.U1z33XAfR0DuYDg37Euz {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: 40px;
}
@media only screen and (max-width: 1023px) {
  .U1z33XAfR0DuYDg37Euz {
    margin-left: 0;
  }
}

.VoiH0rYCExnvbkaUb8nX {
  display: flex;
  align-items: center;
}

.I8zEwxRZCik6mti97xHJ svg {
  fill: #6F767E;
  transition: fill 0.2s;
}
.I8zEwxRZCik6mti97xHJ:hover svg {
  fill: #2A85FF;
}
.I8zEwxRZCik6mti97xHJ:not(:last-child) {
  margin-right: 32px;
}

.g3GBgmrOMqI2rnJ6cgni {
  margin-left: 32px;
}
@media only screen and (max-width: 1023px) {
  .g3GBgmrOMqI2rnJ6cgni {
    margin-left: auto;
  }
}
@media only screen and (max-width: 767px) {
  .g3GBgmrOMqI2rnJ6cgni {
    min-width: 132px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/events/details/Profile/Profile.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AADJ;ACII;EDRJ;IAOQ,mBAAA;IACA,oBAAA;EACN;AACF;ACCI;EDXJ;IAUQ,cAAA;EAIN;AACF;ACDI;EDdJ;IAYQ,mBAAA;IACA,oBAAA;EAON;AACF;ACqKa;ED3KL,qBC6BH;ADpBL;;AAPA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;AAUJ;ACnBI;EDMJ;IAKQ,mBAAA;EAYN;AACF;ACrBI;EDGJ;IAOQ,mBAAA;EAeN;AACF;;AAdA;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAiBJ;AAhBI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAkBR;;AAhBA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBClBC;EDmBD,YAAA;EACA,2BAAA;AAmBJ;AAlBI;EACI,aCZJ;ADgCJ;AAnBI;EACI,mBAAA;AAqBR;;AC3DI;EDwCJ;IAEQ,eAAA;EAsBN;AACF;;AArBA;EACI,eAAA;EACA,cClBC;AD0CL;;AArBA;EACI,aAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AAwBJ;AChFI;EDoDJ;IAMQ,cAAA;EA0BN;AACF;;AAzBA;EACI,aAAA;EACA,mBAAA;AA4BJ;;AAzBI;EACI,aCnCH;EDoCG,qBAAA;AA4BR;AA1BQ;EACI,aCrDP;ADiFL;AA3BI;EACI,kBAAA;AA6BR;;AA3BA;EACI,iBAAA;AA8BJ;ACzGI;ED0EJ;IAGQ,iBAAA;EAgCN;AACF;AC3GI;EDuEJ;IAKQ,gBAAA;EAmCN;AACF","sourcesContent":["@import ../../../../styles/helpers\n\n.profile\n    display: flex\n    align-items: flex-start\n    margin-bottom: 40px\n    padding-bottom: 40px\n    border-bottom: 1px solid $n3\n    +d\n        margin-bottom: 32px\n        padding-bottom: 32px\n    +t\n        display: block\n    +m\n        margin-bottom: 32px\n        padding-bottom: 32px\n    +dark\n        border-color: $n6\n\n.details\n    display: flex\n    align-items: center\n    flex-grow: 1\n    +t\n        margin-bottom: 16px\n    +m\n        margin-bottom: 12px\n\n.avatar\n    position: relative\n    flex-shrink: 0\n    width: 80px\n    height: 80px\n    margin-right: 16px\n    img\n        width: 100%\n        height: 100%\n        object-fit: cover\n        border-radius: 50%\n\n.add\n    position: absolute\n    right: 0\n    bottom: 0\n    width: 24px\n    height: 24px\n    border: 2px solid $n\n    border-radius: 50%\n    background: $p1\n    font-size: 0\n    transition: background .2s\n    svg\n        fill: $n\n    &:hover\n        background: darken($p1, 5)\n\n.man\n    +m\n        font-size: 20px\n\n.info\n    font-size: 12px\n    color: $n4\n    \n\n.contacts\n    display: flex\n    align-items: center\n    flex-shrink: 0\n    margin-left: 40px\n    +t\n        margin-left: 0\n\n.socials\n    display: flex\n    align-items: center\n\n.social\n    svg\n        fill: $n4\n        transition: fill .2s\n    &:hover\n        svg\n            fill: $p1\n    &:not(:last-child)\n        margin-right: 32px\n\n.button\n    margin-left: 32px\n    +t\n        margin-left: auto\n    +m\n        min-width: 132px","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profile": `NUhIFS0BHpH91inuPT83`,
	"details": `d_zIGcuR_Y1T1lDVBdYl`,
	"avatar": `oaAoEyiqqttA__hTS_8V`,
	"add": `_S_Y_dUD5Y7PYr7IIX_A`,
	"man": `qQMaOcVcan1YPfQ8FfNZ`,
	"info": `XmSZemaA3eBJ_y9yMrKe`,
	"contacts": `U1z33XAfR0DuYDg37Euz`,
	"socials": `VoiH0rYCExnvbkaUb8nX`,
	"social": `I8zEwxRZCik6mti97xHJ`,
	"button": `g3GBgmrOMqI2rnJ6cgni`
};
export default ___CSS_LOADER_EXPORT___;
